import { render, staticRenderFns } from "./IklanAss.vue?vue&type=template&id=27767868"
import script from "./IklanAss.vue?vue&type=script&lang=js"
export * from "./IklanAss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports